export const keywords = {
    yes: "Yes",
    no: "No",
    ADD: "ADD",
    EDIT: "EDIT",
};
